{
  "schemaVersion": 1,
  "id": "almaty",
  "officialCityId": "750000000",
  "names": {
    "ru": "Алматы",
    "kk": "Алматы",
    "en": "Almaty"
  },
  "aliases": ["Алматы", "Алма-Ата"],
  "bboxId": "almaty-city",
  "graphId": "almaty-city",
  "bbox": {
    "south": 43.16,
    "west": 76.72,
    "north": 43.42,
    "east": 77.12
  },
  "origin": {
    "lat": 43.29,
    "lon": 76.92
  },
  "view": {
    "center": [76.917, 43.246],
    "zoom": 12.5
  },
  "time": {
    "zone": "Asia/Almaty",
    "utcOffsetMin": 300
  },
  "source": {
    "pbf": "data/pbf/kazakhstan-latest.osm.pbf",
    "extract": "data/pbf/almaty-city.osm.pbf",
    "sha256": "53a639fc0cfdb786089050ba4c18c8a25ed91f7758ec71d934a0257a7d056495",
    "replicationTimestamp": "2026-10-11T20:21:06Z",
    "extractObjectTimestamp": "2026-10-11T17:39:01Z"
  },
  "generatedAt": "2026-10-11T17:39:01Z",
  "routingPolicy": "kz-car-assumptions-v1",
  "compiler": {
    "highwayPolicy": "legacy-v1",
    "signalCollapseM": 30
  },
  "model": {
    "demandPolicy": "buildings-v1",
    "multiplier": 0.04,
    "calibrationStatus": "almaty-baseline",
    "seeds": [1, 2],
    "warmupMinutes": 10,
    "firstSlotMin": 360,
    "slotMinutes": 30,
    "slotCount": 32
  },
  "features": {
    "lanes": true,
    "decks": true,
    "lanePath": true,
    "traffic": true,
    "landmarks": true,
    "ownBuildings": true,
    "transit": true,
    "busRouting": true,
    "cameras": true,
    "overture": true,
    "tripProfiles": true
  },
  "budgets": {
    "archivesBytes": 40000000,
    "trafficBytes": 8000000,
    "lanesBytes": 20000000,
    "decksGzipBytes": 1500000,
    "nativeSetBytes": 63000000,
    "buildRssGiB": 24,
    "maxWorkers": 4,
    "citySetBytes": 150000000
  },
  "bboxes": {
    "small": {
      "id": "almaty-abay-small",
      "title": "Абая – Тимирязева × Ауэзова – Сейфуллина (тестовый квадрат)",
      "south": 43.222,
      "west": 76.898,
      "north": 43.244,
      "east": 76.938,
      "tilesPerSide": 1
    },
    "big": {
      "id": "almaty-center-big",
      "title": "Райымбека – Аль-Фараби × Гагарина – Достык (центр Алматы)",
      "south": 43.216,
      "west": 76.872,
      "north": 43.276,
      "east": 76.962,
      "tilesPerSide": 3
    },
    "city": {
      "id": "almaty-city",
      "title": "Алматы целиком (аэропорт – предгорья × Калкаман – Талгарская трасса)",
      "south": 43.16,
      "west": 76.72,
      "north": 43.42,
      "east": 77.12,
      "tilesPerSide": 8
    }
  },
  "auditRegions": {
    "center": {
      "south": 43.216,
      "west": 76.872,
      "north": 43.276,
      "east": 76.962
    }
  },
  "assumptions": [
    "Спрос зданий buildings-v1; множитель 0,04 — допущение D38.",
    "Скорости местных улиц, эвристика часов, задержки светофоров и съездов — допущения.",
    "D44: полное ожидание на светофорах после модельных линков; не измерение."
  ],
  "status": "live"
}
